export const IDEA_ROLES = Object.freeze({
  ADMIN: 'ADMN',
  MANAGER: 'MNGR',
  OWNER: 'IOWN',
});

export const IDEA_STATUSES = Object.freeze({
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  UNDER_REVIEW: 'UNDER_REVIEW',
  SHORTLISTED: 'SHORTLISTED',
  APPROVED: 'APPROVED',
  CLOSED: 'CLOSED',
  SENT_BACK: 'SENT_BACK',
  ROCK_TUMBLER: 'ROCK_TUMBLER',
  LEGACY: 'LEGACY',
});

export const canPerformAction = ({ role, userEmail, idea, action }) => {
  const safeUserEmail = String(userEmail || '').toLowerCase();
  const submittedBy = String(idea?.submitted_by || '').toLowerCase();
  const assignedManagers = (idea?.assigned_managers || []).map((m) => String(m || '').toLowerCase());

  const isAdmin = role === IDEA_ROLES.ADMIN;
  const isManager = role === IDEA_ROLES.MANAGER;
  const isOwner = role === IDEA_ROLES.OWNER;
  const isIdeaOwner = isOwner && submittedBy === safeUserEmail;

  switch (action) {
    case 'editIdea':
      return isIdeaOwner && [IDEA_STATUSES.DRAFT, IDEA_STATUSES.SENT_BACK].includes(idea?.status);
    case 'assignManagers':
      return isAdmin;
    case 'shortlist':
      return isManager && idea?.status === IDEA_STATUSES.UNDER_REVIEW;
    case 'sendBack':
      return isManager && idea?.status === IDEA_STATUSES.UNDER_REVIEW;
    case 'approve':
      return isAdmin && idea?.status === IDEA_STATUSES.SHORTLISTED;
    case 'close':
      return isAdmin && [IDEA_STATUSES.SHORTLISTED, IDEA_STATUSES.UNDER_REVIEW].includes(idea?.status);
    case 'rate':
      return isManager && assignedManagers.includes(safeUserEmail);
    case 'flagPeerReview':
      return isManager && idea?.status === IDEA_STATUSES.UNDER_REVIEW;
    case 'delete':
      return isAdmin;
    default:
      return false;
  }
};

export const WORKFLOW_STEPS = [
  '1. Idea Owner submits idea with 8QA and tags',
  '2. Super Admin assigns one or more Managers',
  '3. Manager reviews, comments, rates, can trigger AI',
  '4. Manager sends back or shortlists for admin decision',
  '5. Super Admin approves, closes, or reassigns',
  '6. Ratings + AI recommendations support final decision',
];
